import createIcon from './createIcon';
import ChildJoinSvg from './svg/child-join.svg?react';

const ChildJoinIcon = createIcon(ChildJoinSvg);

export default ChildJoinIcon;
